import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

const LANGS = ["de", "en", "fr", "it", "zh"];
const PUBLIC_PATHS = ["/", "/menu", "/reservation", "/takeaway", "/gallery", "/contact", "/impressum", "/privacy"];

export default function LanguageUrlSync() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { lang, setLang } = useLanguage();

  useEffect(() => {
    const match = pathname.match(/^\/(de|en|fr|it|zh)(?:\/|$)/);
    if (match) {
      if (match[1] !== lang) setLang(match[1]);
      return;
    }
    if (PUBLIC_PATHS.includes(pathname)) {
      navigate(`/${lang}${pathname === "/" ? "" : pathname}`, { replace: true });
    }
  }, [pathname, lang, setLang, navigate]);

  return null;
}
